import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff, ShieldCheck, Activity, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const logoUrl = `${process.env.PUBLIC_URL}/logo.png`;
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setError("");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError("Email and password are required.");
      return;
    }
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role !== "admin") {
        setError("Access denied. Admin credentials required.");
        return;
      }
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-auth-shell">
      {/* Ambient grid background */}
      <div className="admin-auth-grid" aria-hidden="true" />

      <div className="admin-auth-wrap">
        {/* Brand */}
        <div className="admin-auth-brand">
          <span className="admin-auth-logo">
            <img src={logoUrl} alt="Lucky Pool logo" className="auth-logo-image" />
          </span>
          {/* <div>
            <strong>Lucky Pool</strong>
            <span>Command Center</span>
          </div> */}
        </div>

        {/* Card */}
        <div className="admin-auth-card">
          <div className="admin-auth-card-top">
            <span className="admin-auth-badge"><Lock size={13} /> Restricted Access</span>
            <h1>Admin Sign In</h1>
            <p>Authenticate to access the Lucky Pool admin panel.</p>
          </div>

          {error && (
            <div className="auth-error admin-auth-error" role="alert">
              <ShieldCheck size={14} /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label htmlFor="adm-email">Admin Email</label>
              <input
                id="adm-email" name="email" type="email"
                autoComplete="email" required
                value={form.email} onChange={handleChange}
                placeholder="admin@luckypool.com"
              />
            </div>
            <div className="auth-field">
              <label htmlFor="adm-password">Password</label>
              <div className="auth-input-wrap">
                <input
                  id="adm-password" name="password"
                  type={showPass ? "text" : "password"}
                  autoComplete="current-password" required
                  value={form.password} onChange={handleChange}
                  placeholder="••••••••"
                />
                <button type="button" className="auth-eye" onClick={() => setShowPass(!showPass)} aria-label="Toggle password">
                  {showPass ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </div>
            <button type="submit" className="admin-auth-submit" disabled={loading}>
              {loading ? <span className="auth-spinner admin-spinner" /> : <><Activity size={16} /> Access Command Center</>}
            </button>
          </form>

          <div className="admin-auth-footer">
            <span>Not an admin?</span>
            <Link to="/login">Go to user login</Link>
          </div>
        </div>

        <p className="admin-auth-disclaimer">
          This area is restricted to authorized personnel only. All access is logged and monitored.
        </p>
      </div>
    </div>
  );
}
